import { motion } from "framer-motion";
import { FlaskConical } from "lucide-react";
import { revealUp, staggerParent, viewportOnce } from "../../lib/motion";

export const WhyLabb = () => {
  return (
    <section data-testid="story-why-labb" className="py-4 sm:py-6">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={staggerParent}
          className="w-full rounded-[28px] bg-labred px-6 py-16 text-center sm:px-12 sm:py-24 lg:py-28"
        >
          <motion.p variants={revealUp} className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-labyellow">
            02 / WHY LABB
          </motion.p>
          <motion.h2
            variants={revealUp}
            className="mx-auto max-w-4xl font-display text-3xl leading-[1.08] tracking-tight text-paper sm:text-5xl"
          >
            BECAUSE &lsquo;KITCHEN&rsquo; DIDN&apos;T COVER IT.
          </motion.h2>
          <motion.p
            variants={revealUp}
            className="mx-auto mt-8 max-w-[820px] font-body text-lg leading-relaxed text-paper/90"
          >
            The symmetry of the flask and the chicken form is the DNA of our identity. It
            seals the two pillars of this brand into a single mark: uncompromising rigor and gastronomic
            creativity. Every recipe is built to the gram. But what separates us from a cold, clinical
            room is the soul and the fire we bring
            to the work.
          </motion.p>

          <motion.div variants={revealUp} className="mt-12 flex items-center justify-center gap-4">
            <span className="h-px w-full max-w-[200px] bg-labyellow/70" />
            <FlaskConical className="h-7 w-7 shrink-0 text-labyellow" strokeWidth={2} />
            <span className="h-px w-full max-w-[200px] bg-labyellow/70" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
